tindie.subscribable = (function(t, $) {
	ko.subscribable = ko.subscribable || {};
	ko.subscribable.fn.subscribeChanged = function(callback) {
		var savedValue = this.peek();
		return this.subscribe(function(latestValue) {
			var oldValue = savedValue;
			savedValue = latestValue;
			callback(latestValue, oldValue);
		});
	};
	return t;
})(tindie.subscribable || {}, jQuery);